<template>
  <div class="ay-home">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>

    <div class="ay-top">
      <div class="ay-top__brand">
        <div class="ay-top__logo">
          <img v-if="$store.state.appInfo.site_logo" class="ay-top__logoImg" :src="$store.state.appInfo.site_logo" alt="" />
          <template v-else>
            <div class="ay-top__logo1">AY</div>
            <div class="ay-top__logo2">AY GAME</div>
          </template>
        </div>
      </div>
      <div class="ay-top__right">
        <div class="ay-top__domain" @click="doCopy($store.state.appInfo.h5_url || 'ay.xh.ms')">
          <span class="ay-top__domainLabel">永久网址：</span>
          <span class="ay-top__domainVal">{{ $store.state.appInfo.h5_url || 'ay.xh.ms' }}</span>
        </div>
        <button type="button" class="ay-top__searchBtn" @click.stop="doCopy($store.state.appInfo.h5_url || 'ay.xh.ms')" aria-label="复制域名">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
            <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>

    <div class="ay-banner" v-if="displayBannerList && displayBannerList.length">
      <div class="ay-banner__card">
        <van-swipe :autoplay="3500" @change="onChange" :show-indicators="false">
          <van-swipe-item v-for="(item, index) in displayBannerList" :key="index">
            <img :src="item.src" class="ay-banner__img" alt="" />
          </van-swipe-item>
        </van-swipe>
        <div class="ay-banner__dots">
          <span v-for="idx in displayBannerList.length" :key="idx" :class="idx - 1 === current ? 'active' : ''"></span>
        </div>
      </div>
    </div>

    <div class="ay-notice">
      <img class="ay-notice__icon" src="/static/image/home_notice.66939586521463adbe87e2a72aa8ecad.png" alt="" />
      <div class="ay-notice__bar">
        <van-notice-bar color="#000" background="transparent" scrollable :speed="50">
          <span v-for="(item, index) in displayNoticeList" @click="openGogao(item)" :key="index">{{ item }}</span>
        </van-notice-bar>
      </div>
    </div>

    <div class="ay-user">
      <div class="ay-user__card">
        <div class="ay-user__info" @click="$parent.goNav($store.state.token ? '/mine' : '/login')">
          <div class="ay-user__titleRow" v-if="$store.state.token">
            <div class="ay-user__title">{{ $store.state.userInfo.username }}</div>
            <div class="ay-user__vip" v-if="$store.state.userInfo && $store.state.userInfo.vip !== undefined && $store.state.userInfo.vip !== null && String($store.state.userInfo.vip) !== ''">
              VIP{{ $store.state.userInfo.vip }}
            </div>
          </div>
          <div class="ay-user__title" v-else>您还未登录</div>
          <div class="ay-user__sub ay-user__sub--balance" v-if="$store.state.token">
            <span>余额：￥{{ $store.state.userInfo.balance }}</span>
            <button type="button" class="ay-balanceRefresh" @click.stop="refreshBalance" aria-label="刷新余额">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 12a9 9 0 0 1-15.364 6.364M3 12a9 9 0 0 1 15.364-6.364"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path d="M21 7v5h-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3 17v-5h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
          <div class="ay-user__sub" v-else>请登录/注册后查看</div>
        </div>
        <div class="ay-user__actions">
          <div class="ay-action" @click="$parent.goNav('/recharge')">
            <div class="ay-action__icon">
              <img src="/iomg2/1.png" alt="" />
            </div>
            <div class="ay-action__label">存款</div>
          </div>
          <div class="ay-action" @click="$parent.goNav('/transfer')">
            <div class="ay-action__icon">
              <img src="/iomg2/2.png" alt="" />
            </div>
            <div class="ay-action__label">转账</div>
          </div>
          <div class="ay-action" @click="$parent.goNav('/withdrawal')">
            <div class="ay-action__icon">
              <img src="/iomg2/3.png" alt="" />
            </div>
            <div class="ay-action__label">取款</div>
          </div>
          <div class="ay-action" @click="$parent.goNav('/vip')">
            <div class="ay-action__icon">
              <img src="/iomg2/4.png" alt="" />
            </div>
            <div class="ay-action__label">VIP</div>
          </div>
        </div>
      </div>
    </div>

    <div class="gameBoxs">
      <div class="lfst">
        <div :class="gameType == -1 ? 'ls active' : 'ls'" @click="changGameType(-1)">
          <img :src="sideIcon(-1)" alt="" />
          <span>热门</span>
        </div>
        <div :class="gameType == 0 ? 'ls active' : 'ls'" @click="changGameType(0)">
          <img :src="sideIcon(0)" alt="" />
          <span>真人</span>
        </div>
        <div :class="gameType == 1 ? 'ls active' : 'ls'" @click="changGameType(1)">
          <img :src="sideIcon(1)" alt="" />

          <span>体育</span>
        </div>
        <div v-if="false" :class="gameType == 2 ? 'ls active' : 'ls'" @click="changGameType(2)">
          <img :src="sideIcon(2)" alt="" />

          <span>电竞</span>
        </div>
        <div :class="gameType == 3 ? 'ls active' : 'ls'" @click="changGameType(3)">
          <img :src="sideIcon(3)" alt="" />

          <span>棋牌</span>
        </div>
        <div :class="gameType == 4 ? 'ls active' : 'ls'" @click="changGameType(4)">
          <img :src="sideIcon(4)" alt="" />

          <span>电子</span>
        </div>
        <div :class="gameType == 5 ? 'ls active' : 'ls'" @click="changGameType(5)">
          <img :src="sideIcon(5)" alt="" />

          <span>彩票</span>
        </div>
        <div :class="gameType == 6 ? 'ls active' : 'ls'" @click="changGameType(6)">
          <img :src="sideIcon(6)" alt="" />

          <span>捕鱼</span>
        </div>
      </div>
      <div class="rigts rigts-list">
        <div class="hotGrid" v-if="gameType === -1">
          <div class="hotTile" v-for="(entry, idx) in currentEntries" :key="entry.key" @click="openEntry(entry)">
            <div class="hotTile__square">
              <div class="hotTile__logo" v-if="entry.img && !entry.hideLogo">
                <img :src="entry.img" alt="" @error="hideHotLogo(entry)" />
              </div>
              <img class="hotTile__poster" v-if="entry.poster && !entry.hidePoster" :src="entry.poster" alt="" @error="hideHotPoster(entry)" />
            </div>
            <div class="hotTile__title">{{ entry.title }}</div>
          </div>
        </div>
        <template v-else>
          <div class="playCard line-card" v-for="(entry, idx) in currentEntries" :key="entry.key" @click="openEntry(entry)">
            <div class="playCard__content line-info">
              <div class="playCard__title line-title">{{ entry.title }}</div>
              <div class="playCard__count">{{ entry.count }}<span>场</span></div>
            </div>
            <img class="playCard__poster" v-if="entry.poster && !entry.hidePoster" :src="entry.poster" alt="" @error="hideHotPoster(entry)" />
            <div class="playCard__bg">{{ entry.bgText }}</div>
          </div>
        </template>
      </div>
    </div>

    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />
        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}
          <van-button type="info" color="#e6cbb0" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
        </div>
      </div>
    </div>

    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />
          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: -1,
      tanshow: true,
      goInfo: null,
      messageNum: 11,
      hiddenGameLogoKeys: {},
      hiddenGamePosterKeys: {},
      appHallRawList: [],
      appHotRawList: [],
      defaultBannerList: [],
      defaultNotices: ['尊敬的客户：欢迎进入平台，祝您游戏愉快'],
    };
  },
  computed: {
    displayBannerList() {
      return this.bannerList && this.bannerList.length ? this.bannerList : [];
    },
    displayNoticeList() {
      return this.homenoticelis && this.homenoticelis.length ? this.homenoticelis : this.defaultNotices;
    },
    currentEntries() {
      if (this.gameType === -1) {
        return (this.hotGameEntries || []).map(it => ({
          key: it.key,
          title: this.formatTitle(it.name),
          bgText: String(it.name || '').toUpperCase(),
          count: it.count,
          img: it.img,
          poster: it.poster,
          hideLogo: !!this.hiddenGameLogoKeys[it.key],
          hidePoster: !!this.hiddenGamePosterKeys[it.key],
          action: it.action,
          url: it.url,
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id,
        }));
      }

      if (this.gameType === 0) {
        return (this.$store.state.realbetList || []).map(it => ({
          key: `realbet-${it.platform_name}`,
          // title: this.formatTitle(it.platform_name, '视讯'),
		  title: this.formatTitle(it.name),
          bgText: String(it.platform_name || '').toUpperCase(),
          count: this.fakeCount(it.platform_name),
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          hideLogo: !!this.hiddenGameLogoKeys[`realbet-${it.platform_name}`],
          hidePoster: !!this.hiddenGamePosterKeys[`realbet-${it.platform_name}`],
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'realbet',
        }));
      }

      if (this.gameType === 1) {
        return (this.$store.state.sportList || []).map(it => ({
          key: `sport-${it.platform_name}`,
          // title: this.formatTitle(it.platform_name, '体育'),
		  title: this.formatTitle(it.name),
          bgText: String(it.platform_name || '').toUpperCase(),
          count: this.fakeCount(it.platform_name),
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          hideLogo: !!this.hiddenGameLogoKeys[`sport-${it.platform_name}`],
          hidePoster: !!this.hiddenGamePosterKeys[`sport-${it.platform_name}`],
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'sport',
        }));
      }

      if (this.gameType === 2) {
        return (this.$store.state.gamingList || []).map(it => ({
          key: `gaming-${it.platform_name}`,
          // title: this.formatTitle(it.platform_name, '电竞'),
		  title: this.formatTitle(it.name),
          bgText: String(it.platform_name || '').toUpperCase(),
          count: this.fakeCount(it.platform_name),
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          hideLogo: !!this.hiddenGameLogoKeys[`gaming-${it.platform_name}`],
          hidePoster: !!this.hiddenGamePosterKeys[`gaming-${it.platform_name}`],
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'gaming',
        }));
      }

      if (this.gameType === 3) {
        return (this.$store.state.jokerList || []).map(it => ({
          key: `joker-${it.platform_name}`,
          // title: this.formatTitle(it.platform_name, '棋牌'),
		  title: this.formatTitle(it.name),
          bgText: String(it.platform_name || '').toUpperCase(),
          count: this.fakeCount(it.platform_name),
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          hideLogo: !!this.hiddenGameLogoKeys[`joker-${it.platform_name}`],
          hidePoster: !!this.hiddenGamePosterKeys[`joker-${it.platform_name}`],
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'joker',
        }));
      }

      if (this.gameType === 4) {
		  // 默认电子列表
        // let fixed = [
        //   { key: 'concise-obgdy', name: 'OB', img: '', poster: '', action: 'open', platform_name: 'obgdy', game_code: 0, sortKey: 'obgdy', category_id: 'concise' },
        //   { key: 'concise-fgdz', name: 'FG', img: '', poster: '', action: 'open', platform_name: 'fgdz', game_code: 0, sortKey: 'fgdz', category_id: 'concise' },
        //   { key: 'concise-pp', name: 'PP', img: '', poster: '', action: 'open', platform_name: 'pp', game_code: 0, sortKey: 'pp', category_id: 'concise' },
        //   { key: 'concise-ae', name: 'AE', img: '', poster: '', action: 'open', platform_name: 'ae', game_code: 0, sortKey: 'ae', category_id: 'concise' },
        // ];
		let fixed =[];

        let dynamic = (this.$store.state.conciseList || []).map(it => ({
          key: `concise-${it.platform_name}`,
          // name: it.platform_name,
		   name: it.name,
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          sortKey: it.platform_name,
          category_id: it.category_id || 'concise',
        }));

        return fixed.concat(dynamic).map(it => ({
          key: it.key,
          // title: it.name.length <= 3 ? `${String(it.name).toUpperCase()}电子` : this.formatTitle(it.name),
		  title: this.formatTitle(it.name),
          bgText: String(it.name || '').toUpperCase(),
          count: this.fakeCount(it.sortKey),
          img: it.img,
          hideLogo: !!this.hiddenGameLogoKeys[it.key],
          poster: it.poster,
          hidePoster: !!this.hiddenGamePosterKeys[it.key],
          action: it.action,
          url: it.url,
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id,
        }));
      }

      if (this.gameType === 5) {
        return (this.$store.state.lotteryList || []).map(it => {
          let imgKey = it.platform_name == 'ig' ? it.game_code : it.platform_name;
          return {
            key: `lottery-${imgKey}`,
            // title: this.formatTitle(it.platform_name, '彩票'),
			title: this.formatTitle(it.name),
            bgText: String(it.platform_name || '').toUpperCase(),
            count: this.fakeCount(imgKey),
            img: this.backendGameImg(it),
            hideLogo: !!this.hiddenGameLogoKeys[`lottery-${imgKey}`],
            poster: this.backendGamePoster(it),
            hidePoster: !!this.hiddenGamePosterKeys[`lottery-${imgKey}`],
            action: 'open',
            platform_name: it.platform_name,
            game_code: it.game_code,
            category_id: it.category_id || 'lottery',
          };
        });
      }

      if (this.gameType === 6) {
        return (this.$store.state.fishingList || []).map(it => ({
          key: `fishing-${it.platform_name}`,
          // title: this.formatTitle(it.platform_name, '捕鱼'),
		  title: this.formatTitle(it.name),
          bgText: String(it.platform_name || '').toUpperCase(),
          count: this.fakeCount(it.platform_name),
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          hideLogo: !!this.hiddenGameLogoKeys[`fishing-${it.platform_name}`],
          hidePoster: !!this.hiddenGamePosterKeys[`fishing-${it.platform_name}`],
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'fishing',
        }));
      }

      return [];
    },
    hotGameEntries() {
      if (Array.isArray(this.appHotRawList) && this.appHotRawList.length) {
        let list = this.appHotRawList.map((it, idx) => {
          let platformName = (it && (it.Code || it.platform_name)) || '';
          let gameCode = it && (it.GameCode !== undefined ? it.GameCode : it.game_code);
          let gameType = it && (it.GameType !== undefined ? it.GameType : it.category_id);
          let categoryId = this.appGameTypeToCategory(gameType);
          let img = this.normalizeBackendUrl(it && (it.app_img || it.img || it.image || it.icon));
          return {
            key: `apphot-${platformName}-${gameCode}-${idx}`,
            name: (it && it.name) || platformName,
            img,
            poster: img,
            action: 'open',
            platform_name: platformName,
            game_code: gameCode,
            category_id: categoryId,
            sortKey: `${platformName}-${gameCode}`,
            raw: it,
          };
        });

        return list.map(it => ({
          ...it,
          count: this.fakeCount(it.sortKey),
        }));
      }

      let list = [];

      let realbet = (this.$store.state.realbetList || []).map(it => ({
        key: `realbet-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'realbet',
        sortKey: it.platform_name,
        raw: it,
      }));

      let sport = (this.$store.state.sportList || []).map(it => ({
        key: `sport-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'sport',
        sortKey: it.platform_name,
        raw: it,
      }));

      let gaming = (this.$store.state.gamingList || []).map(it => ({
        key: `gaming-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'gaming',
        sortKey: it.platform_name,
        raw: it,
      }));

      let joker = (this.$store.state.jokerList || []).map(it => ({
        key: `joker-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'joker',
        sortKey: it.platform_name,
        raw: it,
      }));

      let concise = (this.$store.state.conciseList || []).map(it => ({
        key: `concise-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'concise',
        sortKey: it.platform_name,
        raw: it,
      }));

      let lottery = (this.$store.state.lotteryList || []).map(it => {
        let imgKey = it.platform_name == 'ig' ? it.game_code : it.platform_name;
        return {
          key: `lottery-${imgKey}`,
          name: it.platform_name,
          img: this.backendGameImg(it),
          poster: this.backendGamePoster(it),
          action: 'open',
          platform_name: it.platform_name,
          game_code: it.game_code,
          category_id: it.category_id || 'lottery',
          sortKey: imgKey,
          raw: it,
        };
      });

      let fishing = (this.$store.state.fishingList || []).map(it => ({
        key: `fishing-${it.platform_name}`,
        name: it.platform_name,
        img: this.backendGameImg(it),
        poster: this.backendGamePoster(it),
        action: 'open',
        platform_name: it.platform_name,
        game_code: it.game_code,
        category_id: it.category_id || 'fishing',
        sortKey: it.platform_name,
        raw: it,
      }));

      list = list.concat(realbet, sport, gaming, joker, concise, lottery, fishing);

      let hasHotFlag = list.some(it => {
        let raw = it && it.raw;
        if (!raw) return false;
        return (
          raw.is_hot !== undefined ||
          raw.isHot !== undefined ||
          raw.hot !== undefined ||
          raw.is_top !== undefined ||
          raw.isTop !== undefined ||
          raw.is_recommend !== undefined ||
          raw.isRecommend !== undefined
        );
      });

      if (hasHotFlag) {
        list = list.filter(it => {
          let raw = it && it.raw;
          if (!raw) return false;
          let v =
            raw.is_hot !== undefined
              ? raw.is_hot
              : raw.isHot !== undefined
                ? raw.isHot
                : raw.hot !== undefined
                  ? raw.hot
                  : raw.is_top !== undefined
                    ? raw.is_top
                    : raw.isTop !== undefined
                      ? raw.isTop
                      : raw.is_recommend !== undefined
                        ? raw.is_recommend
                        : raw.isRecommend;
          return v === 1 || v === '1' || v === true;
        });
      }

      let hasOrder = list.some(it => {
        let raw = it && it.raw;
        if (!raw) return false;
        return raw.order_by !== undefined || raw.orderBy !== undefined || raw.sort !== undefined || raw.sort_no !== undefined;
      });

      if (hasOrder) {
        list = list.slice().sort((a, b) => {
          let ar = a && a.raw ? a.raw : {};
          let br = b && b.raw ? b.raw : {};
          let av = ar.order_by !== undefined ? ar.order_by : ar.orderBy !== undefined ? ar.orderBy : ar.sort !== undefined ? ar.sort : ar.sort_no;
          let bv = br.order_by !== undefined ? br.order_by : br.orderBy !== undefined ? br.orderBy : br.sort !== undefined ? br.sort : br.sort_no;
          let an = Number(av);
          let bn = Number(bv);
          if (!Number.isFinite(an)) an = 0;
          if (!Number.isFinite(bn)) bn = 0;
          return an - bn;
        });
      }

      return list.map(it => ({
        ...it,
        count: this.fakeCount(it.sortKey),
      }));
    },
  },
  created() {
    let that = this;
    that.getBanList();
    that.fetchAppHallList();
    that.homenotice(); //获取公告
    that.messageNum = that.$store.state.messageNum || that.messageNum;
  },
  methods: {
    fakeCount(key) {
      let str = String(key || '');
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
      }
      return (hash % 1901) + 100;
    },
    formatTitle(name, suffix = '') {
      let n = String(name || '').trim();
      if (!n) return '';
      if (/[\u4e00-\u9fa5]/.test(n)) return n;
      let up = n.toUpperCase();
      let s = String(suffix || '').trim();
      if (!s) return up;
      if (up.endsWith(s)) return up;
      return `${up}${s}`;
    },
    openGogao(val) {
      this.goInfo = val;
    },
    refreshBalance() {
      if (!this.$store.state.token) return;
      let p = this.$parent;
      if (p && typeof p.getBalance === 'function') {
        p.getBalance();
        return;
      }
      if (p && typeof p.getUserInfoShowLoding === 'function') {
        p.getUserInfoShowLoding();
      }
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.gameType = type;
    },
    hideHotLogo(entry) {
      if (!entry || !entry.key) return;
      this.$set(this.hiddenGameLogoKeys, entry.key, true);
    },
    hideHotPoster(entry) {
      if (!entry || !entry.key) return;
      this.$set(this.hiddenGamePosterKeys, entry.key, true);
    },
    normalizeBackendUrl(raw) {
      if (!raw || typeof raw !== 'string') return '';
      let val = raw.trim();
      if (!val) return '';
      if (/^(data:|blob:)/i.test(val)) return val;
      if (/^https?:\/\//i.test(val)) return val;
      if (/^\/\//.test(val)) return val;
      let baseURL = sessionStorage.getItem('baseURL') || '';
      if (val.startsWith('/')) {
        if (baseURL && val.startsWith('/uploads/')) {
          if (baseURL.endsWith('/')) baseURL = baseURL.slice(0, -1);
          return `${baseURL}${val}`;
        }
        return val;
      }
      if (!baseURL) return val;
      if (baseURL.endsWith('/')) baseURL = baseURL.slice(0, -1);
      return `${baseURL}/${val}`;
    },
    backendGameImg(item) {
      if (!item) return '';
      let candidates = [
        item.api_logo_img,
        item.header_logo,
        item.app_img,
        item.check_yes_img,
        item.check_no_img,
        item.img,
        item.image,
        item.icon,
        item.logo,
        item.pic,
        item.cover,
        item.platform_icon,
        item.platform_logo,
        item.platform_img,
        item.game_icon,
        item.game_logo,
        item.game_img,
        item.app_icon,
        item.app_logo,
        item.h5_icon,
        item.h5_logo,
        item.mobile_icon,
        item.mobile_logo,
      ];
      let raw = candidates.find(v => typeof v === 'string' && v.trim());
      return this.normalizeBackendUrl(raw);
    },
    backendGamePoster(item) {
      if (!item) return '';
      let candidates = [
        item.mobile_img,
        item.app_img,
        item.poster,
        item.poster_img,
        item.poster_image,
        item.poster_url,
        item.bg,
        item.bg_img,
        item.bg_image,
        item.bg_url,
        item.background,
        item.background_img,
        item.background_image,
        item.background_url,
        item.banner,
        item.banner_img,
        item.banner_image,
        item.banner_url,
        item.cover,
        item.cover_img,
        item.cover_image,
        item.cover_url,
        item.check_yes_img,
        item.check_no_img,
        item.gamepic,
        item.game_pic,
        item.game_picture,
        item.game_picture_url,
        item.platform_pic,
        item.platform_picture,
      ];
      let raw = candidates.find(v => typeof v === 'string' && v.trim());
      return this.normalizeBackendUrl(raw);
    },
    sideIcon(type) {
      const isActive = this.gameType === type;
      if (type === -1) {
        return isActive ? '/dhy/x.png' : '/rm.png';
      }
      const map = {
        0: 1,
        1: 2,
        2: 3,
        3: 4,
        4: 5,
        5: 6,
        6: 7,
      };
      const idx = map[String(type)];
      return idx ? `/dhy/${idx}${isActive ? '-1' : ''}.png` : '/dhy/x.png';
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let rawList = Array.isArray(res.data) ? res.data : [];
            that.bannerList = rawList
              .map(it => {
                if (typeof it === 'string') {
                  return { src: that.normalizeBackendUrl(it) };
                }
                if (!it || typeof it !== 'object') return null;
                let raw =
                  it.src ||
                  it.url ||
                  it.image ||
                  it.img ||
                  it.pic ||
                  it.banner ||
                  it.banner_url ||
                  it.banner_img ||
                  it.banner_image ||
                  it.cover ||
                  it.cover_url ||
                  it.cover_img ||
                  it.cover_image ||
                  it.h5_banner ||
                  it.h5_banner_url ||
                  it.mobile_banner ||
                  it.mobile_banner_url ||
                  it.pc_banner ||
                  it.pc_banner_url ||
                  it.path ||
                  it.filepath ||
                  it.file_path;
                let src = that.normalizeBackendUrl(raw);
                if (!src) return null;
                return { ...it, src };
              })
              .filter(Boolean);
          }
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    openEntry(entry) {
      if (!entry) return;
      if (entry.action === 'nav') {
        this.$parent.goNav(entry.url);
        return;
      }
      this.$parent.openGamePage(entry.platform_name, entry.game_code, entry.category_id || '');
    },
    appGameTypeToCategory(gameType) {
      let v = gameType;
      if (typeof v === 'string') {
        let s = v.trim();
        if (!s) return '';
        if (/^\d+$/.test(s)) v = Number(s);
        else return s;
      }
      if (v === 2) return 'fishing';
      if (v === 3) return 'concise';
      if (v === 4) return 'lottery';
      if (v === 5) return 'sport';
      if (v === 6) return 'joker';
      if (v === 7) return 'gaming';
      return '';
    },
    fetchAppHallList() {
      let that = this;
      that.$apiFun
        .post('/api/app/hall_list', {})
        .then(res => {
          if (!res || res.code != 200) return;
          let data = res.data || {};
          that.appHallRawList = Array.isArray(data.list) ? data.list : [];
          that.appHotRawList = Array.isArray(data.hot) ? data.hot : [];
        })
        .catch(() => {});
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
.ay-home {
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 49px;
  padding-bottom: calc(49px + env(safe-area-inset-bottom));
}
.ay-appbar {
  position: sticky;
  top: 0;
  z-index: 20;
  height: 0.96rem;
  padding: 0 0.24rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.06);
}
.ay-appbar__left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}
.ay-appbar__close {
  width: 0.48rem;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  border-radius: 0.24rem;
  color: #999;
  font-size: 0.44rem;
  margin-right: 0.16rem;
}
.ay-appbar__badge {
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 0.16rem;
  background: #d7c5b1;
  color: #fff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.16rem;
  flex: 0 0 auto;
  overflow: hidden;
}
.ay-appbar__badgeImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ay-appbar__text {
  min-width: 0;
}
.ay-appbar__title {
  font-size: 0.28rem;
  color: #333;
  font-weight: 600;
  line-height: 0.34rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ay-appbar__sub {
  font-size: 0.22rem;
  color: #999;
  line-height: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ay-appbar__btn {
  flex: 0 0 auto;
  height: 0.56rem;
  line-height: 0.56rem;
  padding: 0 0.24rem;
  border-radius: 0.28rem;
  background: #d9c3a4;
  color: #fff;
  font-size: 0.24rem;
  font-weight: 600;
}
.ay-top {
  padding: 0.22rem 0.28rem 0.12rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ay-top__logo1 {
  font-size: 0.44rem;
  font-weight: 800;
  color: #d3a675;
  line-height: 0.5rem;
}
.ay-top__logo2 {
  font-size: 0.22rem;
  color: #b09a84;
  margin-top: 0.06rem;
}
.ay-top__logoImg {
  display: block;
  height: 0.86rem;
  width: auto;
  object-fit: contain;
}
.ay-top__right {
  display: flex;
  align-items: center;
  gap: 0.14rem;
}
.ay-top__domain {
  font-size: 0.24rem;
  color: #6d6257;
  background: transparent;
  padding: 0;
  border-radius: 0;
  max-width: 4.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ay-top__searchBtn {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
  border: none;
  background: transparent;
  color: #3d342c;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ay-top__searchBtn svg {
  width: 0.38rem;
  height: 0.38rem;
  display: block;
}
.ay-top__domainVal {
  color: #3d342c;
  font-weight: 600;
}
.ay-banner {
  background: #ffffff;
  padding: 0.12rem 0.28rem 0.16rem;
}
.ay-banner__card {
  position: relative;
  border-radius: 0.28rem;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.06);
}
.ay-banner__img {
  display: block;
  width: 100%;
  height: 160px;
  object-fit: cover;
}
.ay-banner__dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.14rem;
  display: flex;
  justify-content: center;
  gap: 0.12rem;
}
.ay-banner__dots span {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 0.06rem;
  background: rgba(217, 195, 164, 0.75);
}
.ay-banner__dots span.active {
  width: 0.28rem;
  background: rgba(191, 167, 140, 0.95);
}
.ay-notice {
  background: #faf4ee;
  border-radius: 999px;
  margin: 0.12rem 0.28rem 0;
  min-height: 0.64rem;
  padding: 0 0.28rem;
  display: flex;
  align-items: center;
  gap: 0.16rem;
  overflow: hidden;
}
.ay-notice__icon {
  width: 0.36rem;
  height: 0.36rem;
}
.ay-notice__bar {
  flex: 1;
  min-width: 0;
}
.ay-notice__bar .van-notice-bar {
  height: 0.64rem;
  line-height: 0.64rem;
  padding: 0;
}
.ay-notice__right {
  flex: 0 0 auto;
  height: 0.44rem;
  border-radius: 0.22rem;
  background: #f2e7dc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.18rem;
}
.ay-notice__more {
  font-size: 0.22rem;
  font-weight: 600;
  color: #a66f4d;
}
.ay-user {
  background: #ffffff;
  padding: 0.18rem 0.28rem 0;
}
.ay-user__card {
  background: #ffffff;
  border-radius: 0.22rem;
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.05);
  padding: 0.22rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.18rem;
}
.ay-user__info {
  flex: 1;
  min-width: 0;
}
.ay-user__titleRow {
  display: flex;
  align-items: center;
  gap: 0.12rem;
  min-width: 0;
}
.ay-user__title {
  font-size: 0.26rem;
  color: #3d342c;
  font-weight: 600;
  line-height: 0.36rem;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ay-user__vip {
  flex: 0 0 auto;
  height: 0.28rem;
  line-height: 0.28rem;
  padding: 0 0.12rem;
  font-size: 0.18rem;
  font-weight: 700;
  color: #ffffff;
  border-radius: 0.14rem;
  background: #b88956;
}
.ay-user__sub {
  margin-top: 0.04rem;
  font-size: 0.22rem;
  color: #8e7d6e;
}
.ay-user__sub--balance {
  display: inline-flex;
  align-items: center;
  gap: 0.12rem;
}
.ay-balanceRefresh {
  width: 0.28rem;
  height: 0.28rem;
  padding: 0;
  border: 1px solid rgba(126, 110, 96, 0.32);
  border-radius: 0.14rem;
  background: rgba(255, 255, 255, 0.7);
  color: #7e6e60;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ay-balanceRefresh svg {
  width: 0.18rem;
  height: 0.18rem;
  display: block;
}
.ay-user__actions {
  display: flex;
  gap: 0.26rem;
}
.ay-action {
  width: 0.84rem;
  text-align: center;
}
.ay-action__icon {
  width: 0.84rem;
  height: 0.84rem;
  margin: 0 auto;
  border-radius: 0.32rem;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.ay-action__icon img {
  width: 0.84rem;
  height: 0.84rem;
}
.ay-action__label {
  margin-top: 0.12rem;
  font-size: 0.2rem;
  color: #7e6e60;
}
.ay-main {
  padding: 0.2rem 0.28rem 1.4rem;
  display: flex;
  gap: 0.16rem;
}
.ay-cats {
  width: 1.12rem;
  flex: 0 0 auto;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.12rem 0.08rem;
}
.ay-cat {
  height: 0.98rem;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
  color: #9a8b7c;
}
.ay-cat__icon {
  font-size: 0.34rem;
  line-height: 0.34rem;
}
.ay-cat__label {
  font-size: 0.22rem;
}
.ay-cat.active {
  background: #d3a675;
  color: #fff;
}
.ay-list {
  flex: 1;
  min-width: 0;
}
.ay-gamecard {
  position: relative;
  height: 1.64rem;
  border-radius: 0.22rem;
  background: #ffffff;
  overflow: hidden;
  padding: 0.26rem 0.26rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.18rem;
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.05);
}
.ay-gamecard__dot {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 0.08rem;
  background: #d3a675;
  margin-right: 0.16rem;
  flex: 0 0 auto;
}
.ay-gamecard__content {
  position: relative;
  z-index: 2;
  min-width: 0;
}
.ay-gamecard__title {
  font-size: 0.34rem;
  font-weight: 800;
  color: #2f2a26;
  line-height: 0.42rem;
}
.ay-gamecard__count {
  margin-top: 0.1rem;
  font-size: 0.3rem;
  color: #c08f60;
  font-weight: 700;
}
.ay-gamecard__count span {
  font-size: 0.22rem;
  font-weight: 500;
  margin-left: 0.06rem;
  color: #b59c86;
}
.ay-gamecard__bg {
  position: absolute;
  left: 0.22rem;
  bottom: -0.16rem;
  font-size: 0.92rem;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.04);
  letter-spacing: 0.02rem;
  z-index: 1;
  pointer-events: none;
}
.ay-gamecard__person {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 1.9rem;
  z-index: 2;
}
.domainModal_content__1nBgc {
  overflow: auto;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #ede9e7;
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .mey {
      margin-top: 3px;
      font-size: 16px;
      font-weight: 700;
      span {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 56px;
      text-align: center;
      font-size: 12px;
      img {
        width: 60%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.xiding {
  background-color: #ede9e7;
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

// 游戏
.gameBoxs {
  background: #ffffff;
  -webkit-box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-sizing: border-box;
  padding: 10px;
  color: #cf866b;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  justify-content: space-between;
  .lfst {
    width: 58px;
    height: 100%;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #fff;
    display: block;
    overflow: auto;
    padding: 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .ls.active {
      color: #fff;
      background: url('../../../iomg2/beijing.png') 50% 100% / 100% 100% no-repeat;
    }
    .ls {
      text-align: center;
      border-radius: 3px;
      padding: 0;
      margin: 8px 5px;
      background: url('../../../iomg2/heis.png') 50% 100% / 100% 100% no-repeat;
      color: #9a8b7c;
      img {
        width: 30px;
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 12px;
        display: block;
      }
    }
  }
  .rigts {
    flex: 1;
    overflow: auto;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    padding: 0 0 0 12px;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
  .hotGrid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    padding-right: 2px;
  }
  .hotTile {
    min-width: 0;
  }
  .hotTile__square {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
    border-radius: 14px;
    background: #ffffff;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  }
  .hotTile__poster {
    position: absolute;
    right: -10px;
    bottom: 0;
    height: 92%;
    opacity: 0.95;
  }
  .hotTile__logo {
    position: absolute;
    left: 8px;
    top: 8px;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hotTile__logo img {
    width: 20px;
    height: 20px;
    display: block;
  }
  .hotTile__title {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #2f2a26;
    text-align: center;
    font-family: 'Altinn-DIN', DINPro, PingFang SC, Helvetica Neue, Hiragino Sans GB, Helvetica, Microsoft YaHei, Arial, sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hotTile__count {
    margin-top: 2px;
    font-size: 14px;
    font-weight: 600;
    color: #c08f60;
    text-align: center;
  }
  .playCard {
    position: relative;
    height: 96px;
    border-radius: 16px;
    background: #ffffff;
    overflow: hidden;
    padding: 16px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  }
  .playCard::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 44px;
    height: 44px;
    background: url('../../../iomg2/jiaobiao.png') left top / 100% 100% no-repeat;
    z-index: 5;
    pointer-events: none;
  }
  .playCard__content {
    position: relative;
    z-index: 3;
    min-width: 0;
  }
  .line-info {
    font-family: 'YSJLT', Arial, sans-serif;
    flex: 1;
    min-width: 0;
  }
  .playCard__title {
    font-size: 24px;
    color: #1f2333;
    line-height: 1.2;
    margin-top: 8px;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 700;
    font-family: 'YSJLT', 'Altinn-DIN', DINPro, PingFang SC, Helvetica Neue, Hiragino Sans GB, Helvetica, Microsoft YaHei, Arial, sans-serif;
  }
  .line-title {
    font-size: 24px;
    color: #1f2333;
    line-height: 1.2;
    margin-top: 8px;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .playCard__count {
    margin-top: 0;
    font-size: 20px;
    color: #c08f60;
    font-weight: 700;
    font-family: 'YSJLT', 'Altinn-DIN', DINPro, PingFang SC, Helvetica Neue, Hiragino Sans GB, Helvetica, Microsoft YaHei, Arial, sans-serif;
  }
  .playCard__count span {
    font-size: 12px;
    font-weight: 500;
    margin-left: 4px;
    color: #b59c86;
  }
  .playCard__bg {
    position: absolute;
    left: 14px;
    bottom: -10px;
    font-size: 52px;
    font-weight: 900;
    color: rgba(0, 0, 0, 0.04);
    letter-spacing: 1px;
    z-index: 0;
    pointer-events: none;
  }
  .playCard__logo {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 28px;
    height: 28px;
    object-fit: contain;
    z-index: 4;
    opacity: 0.85;
  }
  .playCard__poster {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 118px;
    z-index: 1;
    pointer-events: none;
  }
}
// app下载
.appbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.8rem;
  box-sizing: border-box;
  padding-right: 15px;
  .colse {
    width: 0.4rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: 1rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.23rem;
      font-weight: 700;
    }
    .cx {
      font-size: 0.2rem;
      color: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue